var exports = {
  "rf": "x04b3a21e--8f3cba--body",
  "Qq": "x04b3a21e--8f3cba--text",
  "q9": "x04b3a21e--8f3cba--price",
  "FI": "x04b3a21e--8f3cba--parameters",
  "qr": "x04b3a21e--8f3cba--footer",
};

module.exports = exports;
